// back_cover — dark closing slide (v15 slide 23): the NAVEN lockup large, the contact/company
// lines in mono below it, and the confidentiality note as the footline.
import type { BackCoverContent } from '../../../../shared/deckTypes.js';
import { Abs, Dkp, PageNo, Rule } from './chrome.js';

export default function BackCoverPreview({ content, pageNo }: {
  content: BackCoverContent;
  pageNo?: number | null;
}) {
  const c = content;
  const lines = (c.lines ?? []).slice(0, 8);

  return (
    <Dkp variant="dark">
      <Abs x={64} y={330}>
        <span style={{ fontSize: 29.3, fontWeight: 900, letterSpacing: '-.005em', color: '#F3F1EC' }}>
          NAVEN<span className="dkp-brand--dot">●</span>
        </span>
      </Abs>
      {c.tagline ? (
        <Abs x={64} y={382} w={600}>
          <span style={{ fontSize: 14.7, fontWeight: 500, color: '#D9D6CF' }}>{c.tagline}</span>
        </Abs>
      ) : null}

      {/* mono lines on a 19px pitch; an empty line leaves a 10px gap (v15: contact, gap, company) */}
      <Abs x={64} y={452} w={720}>
        {lines.map((line, i) => line.trim() === ''
          ? <div key={i} style={{ height: 10 }} />
          : (
            <div key={i} className="dkp-mono" style={{
              height: 19, fontSize: 10.7, letterSpacing: '.08em', textTransform: 'uppercase', color: '#9A9DA3',
            }}>{line}</div>
          ))}
      </Abs>

      <Rule x={64} y={662} w={1152} color="#3A3C41" />
      {c.note ? (
        <Abs x={64} y={676} w={1000}>
          <span className="dkp-mono" style={{
            fontSize: 9.3, letterSpacing: '.09em', textTransform: 'uppercase', color: '#9A9DA3',
          }}>{c.note}</span>
        </Abs>
      ) : null}

      <PageNo n={pageNo} light />
    </Dkp>
  );
}
